<template>
  <el-dialog title="复制资料" :visible.sync="copyDialogVisible" width="550px">
    <div class="copy-dialog-content">
      <div class="">
        <div class="copy-dialog-title">
          由于操作后不可逆，请慎重操作!如果当前公司存在一个部门，则无法复制成功。
        </div>
        <div>
          将为 【{{ copyDialogData.targetTenantName }}】 创建以下资料模版为（{{
            copyDialogData.templateName
          }}）：
        </div>
      </div>
      <div v-for="item in copyItems" :key="item.label" class="copy-dialog-item">
        {{ item.label }}（{{ item.count }}{{ item.unit }}）
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="copyDialogVisible = false">取消</el-button>
      <el-button
        size="mini"
        type="info"
        :loading="confirmLoading"
        @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { saveCopyData } from "@/api/msCustomerService.js";
import { getOrganisationList } from "@/api/msPersonnelService.js";
export default {
  data() {
    return {
      copyDialogVisible: false,
      confirmLoading: false,
      copyDialogData: {
        sourceTenantGuid: "",
        targetTenantGuid: "",
        targetTenantName: "",
        templateName: "",
        copyCount: {},
      },
    };
  },
  computed: {
    copyItems() {
      const copyCount = this.copyDialogData.copyCount || {};
      return [
        {
          label: "组织架构",
          count: this.getDynamicCount(copyCount, "orgTotalCount"),
          unit: "个组织",
        },
        {
          label: "岗位信息",
          count: this.getDynamicCount(copyCount, "positionTotalCount"),
          unit: "个岗位",
        },
        {
          label: "人员账号",
          count: this.getDynamicCount(copyCount, "staffTotalCount"),
          unit: "个人员",
        },
        {
          label: "销售区域",
          count: this.getDynamicCount(copyCount, "salesTerritoryTotalCount"),
          unit: "个区域",
        },
        {
          label: "角色信息",
          count: this.getDynamicCount(copyCount, "roleTotalCount"),
          unit: "个角色",
        },
        {
          label: "流程名称",
          count: this.getDynamicCount(copyCount, "flowTotalCount"),
          unit: "个流程",
        },
        {
          label: "核算单元",
          count: this.getDynamicCount(copyCount, "unitTotalCount"),
          unit: "个单元",
        },
      ];
    },
  },
  methods: {
    getDynamicCount(source, key, defaultValue = 0) {
      const value = source && source[key];
      if (!value) {
        return defaultValue;
      }
      const count = Number(value);
      return Number.isNaN(count) ? defaultValue : count;
    },
    open(data) {
      this.copyDialogData = {
        sourceTenantGuid: data.sourceTenantGuid || "",
        targetTenantGuid: data.targetTenantGuid || "",
        targetTenantName: data.targetTenantName || "",
        templateName: data.templateName || "",
        copyCount: data.copyCount || {},
      };
      this.confirmLoading = false;
      this.copyDialogVisible = true;
    },

    /**
     * 校验企业是否已存在组织
     */
    async checkOrganisationExists() {
      const { data } = await getOrganisationList({
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 10,
        tenantGuid: this.copyDialogData.targetTenantGuid,
      });
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return false;
      }
      return data.data.records.length > 0;
    },

    async handleConfirm() {
      // 校验企业是否已存在组织
      const exists = await this.checkOrganisationExists();
      if (exists) {
        this.$message.error("当前服务商已存在一个组织，不可复制");
        return;
      }

      const saveData = {
        sourceTenantGuid: this.copyDialogData.sourceTenantGuid,
        targetTenantGuid: this.copyDialogData.targetTenantGuid,
        targetTenantName: this.copyDialogData.targetTenantName,
        tenantGuid: localStorage.getItem("guid"),
      };
      this.confirmLoading = true;
      const { data } = await saveCopyData(saveData);
      this.copyDialogVisible = false;
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.$message.success("复制资料成功");
      this.$emit("success");
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding-top: 0;
  padding-bottom: 0;
}
.copy-dialog-content {
  line-height: 24px;
  text-align: left;
  padding-top: 0px;
}
.copy-dialog-title {
  color: #dd233c;
}
.copy-dialog-item {
  margin-top: 4px;
  color: #ff4444;
}
</style>
